// extracted by mini-css-extract-plugin
export default {"warningIcon":"style_warningIcon__DH2ID","switchToHqButtonWrapper":"style_switchToHqButtonWrapper__6RUGs","loaderWrapper":"style_loaderWrapper__bYRjB"};